// src/components/QRDisplay.js
import React from "react";
import { QRCodeCanvas } from "qrcode.react";
import "./QRDisplay.css";

const QRDisplay = () => {
  const qrValue = "https://menu-rtl.ir/menu?table=5"; // لینک ngrok یا IP سیستم شما

  return (
    <div className="overlay">
      <h3>میز : 5</h3>
      <h1>🍽️ منوی دیجیتال ما را همین حالا ببین!</h1>
      <p>کافی‌ست QR روی میز را اسکن کنید و غذا سفارش دهید</p>
      <div className="qr-box">
        <QRCodeCanvas value={qrValue} size={250} />
        <p>کافیه با دوربین گوشی‌ات اسکن کنی 📱</p>
      </div>
    </div>
  );
};

export default QRDisplay;
